import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-legend-type-tornado",
  "use": "icon-legend-type-tornado-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-legend-type-tornado\"><path d=\"M14.352 2.667h-12m11.333 2.666H4.352m8 2.667h-6m4 2.667H5.685m6 2.666H8.352\" stroke=\"#4C556C\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol